import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NoteType } from '@app/shared/components/note/note.interface';
import { IntercomService } from '@app/shared/services/intercom.service';

@Component({
  standalone: false,
  selector: 'sbnb-connect-airbnb-unofficial-phase1',
  templateUrl: './connect-airbnb-unofficial-phase1.component.html',
  styleUrls: ['./connect-airbnb-unofficial-phase1.component.scss'],
})
export class ConnectAirbnbUnofficialPhase1Component implements OnInit {
  @Input() loading: boolean;
  @Input() login: string;
  @Output() phaseComplete: EventEmitter<any> = new EventEmitter();

  NoteType = NoteType;

  constructor(private readonly intercomService: IntercomService) { }

  ngOnInit(): void { }

  contactSupport() {
    this.intercomService.showNewMessage('I have a question before I upgrade my Airbnb account.');
  }
}
